import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CustomTheme {
  id: string
  name: string
  css: string
}

interface ThemeState {
  activeThemeId: string
  customThemes: CustomTheme[]
  setActiveTheme: (id: string) => void
  addCustomTheme: (name: string, css: string) => void
  removeCustomTheme: (id: string) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      activeThemeId: 'default',
      customThemes: [],
      setActiveTheme: (id) => set({ activeThemeId: id }),
      addCustomTheme: (name, css) =>
        set((state) => ({
          customThemes: [
            ...state.customThemes,
            { id: `custom-${Date.now()}`, name, css },
          ],
        })),
      removeCustomTheme: (id) =>
        set((state) => ({
          activeThemeId: state.activeThemeId === id ? 'default' : state.activeThemeId,
          customThemes: state.customThemes.filter((t) => t.id !== id),
        })),
    }),
    { name: 'admin-theme' },
  ),
)
